import { render, staticRenderFns } from "./AgreementViewer.vue?vue&type=template&id=b525fd98&scoped=true&"
import script from "./AgreementViewer.vue?vue&type=script&lang=js&"
export * from "./AgreementViewer.vue?vue&type=script&lang=js&"
import style0 from "./AgreementViewer.vue?vue&type=style&index=0&id=b525fd98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b525fd98",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b525fd98')) {
      api.createRecord('b525fd98', component.options)
    } else {
      api.reload('b525fd98', component.options)
    }
    module.hot.accept("./AgreementViewer.vue?vue&type=template&id=b525fd98&scoped=true&", function () {
      api.rerender('b525fd98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/agreements/viewer/AgreementViewer.vue"
export default component.exports